import { Helmet } from "react-helmet";

export default function CrawlingConfig() {
  const isProd = import.meta.env.VITE_PROD === "true";

  return isProd ? (
    <Helmet>
      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
      <meta
        name="googlebot"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />
    </Helmet>
  ) : (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
    </Helmet>
  );
}
